// Angular
import { Component, ViewEncapsulation, OnInit } from '@angular/core';

// Rxjs
import { Store } from '@ngrx/store';

// Actions
import * as userActions from '../store/user/user.actions';

// Services
import { SoledadAuthenticationService } from '../shared/services/b2b/auth.service';
import { TranslateService } from '@ngx-translate/core';

// Helpers
import { Subscriber } from '../shared/lib/helpers/subscriber';
import { isEmptyObject } from '../shared/lib/helpers/utils';

// Store
import * as RouterActions from '../store/router/router.actions';
import { AppState } from '../store';
import { SearchSettings } from '../shared/models/b2b/searchSettings';

@Component({
    selector: 'app-404',
    templateUrl: '404.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PageNotFoundComponent extends Subscriber implements OnInit {
    lang: string;
    user: any;

    constructor(
        private store: Store<AppState>,
        private translate: TranslateService,
        private authService: SoledadAuthenticationService
    ) {
        super();
    }

    ngOnInit() {
        this.isLoggedIn();
        this.subscribeUserSearchSettings();
    }

    backToLogin(ev): void {
        ev.preventDefault();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['login']
            })
        );
    }

    setDefaultLanguage(settings: SearchSettings): void {
        // Set current lang. Default 'es'
        if (!settings.language) {
            this.lang = 'es';
            this.translate.use(this.lang);
        } else {
            this.lang = settings.language;
            this.translate.use(this.lang);
        }
    }

    setBrowserLang(): void {
        this.lang = navigator.language.substring(0, 2).toLowerCase();
    }

    isLoggedIn(): void {
        if (!this.authService.isLoggedIn()) {
            this.setBrowserLang();
        } else {
            this.subscribeUserData();
        }
    }

    subscribeUserSearchSettings(): void {
        this.addSubscription(
            this.store
                .select((state) => state.user.settings)
                .subscribe((settings) => {
                    if (settings && !isEmptyObject(this.user)) {
                        this.setDefaultLanguage(settings);
                    }
                })
        );
    }

    subscribeUserData(): void {
        this.addSubscription(
            this.store
                .select((state) => state.user.data)
                .subscribe((user) => {
                    if (user) {
                        this.user = user;
                        this.store.dispatch(new userActions.DoGetSettings(!!user));
                    }
                })
        );
    }
}
